import React, { useEffect, useState } from 'react';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import {
    applications,
    useCurrentClient,
    useCurrentApplication,
    useAlliLayout,
} from '@alli/frontend-common';
import Sidebar from './components/Sidebar';

const defaultWidth = 'w-16';
const expandedWidth = 'w-271';

export default function Root({ location, history, singleSpa }) {
    const currentApp = useCurrentApplication();

    // we copy the current client locally because the current client _can_ be
    // null when the app is loading or when clients are being switched. If we have
    // that happen, we don't want to hide then show the sidebar. So keep a local
    // copy of the current client around and update that when the client changes.
    // This mimics what the actual theme provider from the alli component libary.
    // https://github.com/AgencyPMG/alli-ui/blob/85e8a0fb29d824d934dd5d2cc607a5dc56be4b39/src/components/ThemeProvider.js#L35-L39
    const currentClient = useCurrentClient();
    const [localCurrentClient, setLocalCurrentClient] = useState(currentClient);

    const { collapseSidebar } = useAlliLayout();

    useEffect(() => {
        if (currentClient && localCurrentClient?.id !== currentClient.id) {
            setLocalCurrentClient(currentClient);
        }
    }, [currentClient, localCurrentClient?.id]);

    return (
        <OpenFeatureProvider>
            <Sidebar
                menuItems={applications.menu}
                bottomMenuItems={applications.bottomMenu}
                collapseSidebar={collapseSidebar}
                activeApp={currentApp.activeInSidebar || currentApp.id}
                activeSubnavItem={currentApp.activeSubnavItem}
                currentClient={localCurrentClient}
                navigateToUrl={singleSpa.navigateToUrl}
            />
        </OpenFeatureProvider>
    );
}
